const emptyColorPalette = () => ({
  lighter: '',
  light: '',
  color: '',
  dark: '',
  darker: '',
  hover: '',
  contrastText: '',
  hoverContrastText: ''
});
export const emptyTheme = () => ({
  font: {
    general: '',
    headings: '',
    headingsWeight: '',
    size: ''
  },
  primary: emptyColorPalette(),
  secondary: emptyColorPalette(),
  tertiary: emptyColorPalette(),
  buttons: {
    radius: ''
  }
});